var global = require('../internals/global');
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = function (CONSTRUCTOR, METHOD) {
  return uncurryThis(global[CONSTRUCTOR].prototype[METHOD]);
};



// WEBPACK FOOTER //
// ./node_modules/core-js/internals/entry-unbind.js